import React from 'react';
import styled from 'styled-components';
import Button from '../../../../../../../Common/BaseComponentWrappers/MotifButton';
import {useDispatch} from 'react-redux';
import {serviceURL, independenceStatus, engagementAccessType} from '../../../../../../../../util/uiconstants';
import {labels} from '../../../../../../../../util/utils';
import env from '../../../../../../../../util/env';
import {submitIndependence} from '../../../../../../../../actions/FormData/formdataactions';
import {useUserPreferences} from '../../../../../../../../util/customHooks';
import {createIndependenceSnapshotUrl} from '../../../../../../../../actions/apiUrls';
import {createCanvasFormSnapshot} from '../../../../../../../../actions/Task/signoffsaction';
import {raiseJSValidationError} from '../../../../../../../../actions/erroractions';

export default function SubmitButton(props) {
	const {engagementId, documentId, document, showLoading, disableButton, setDisableButton} = props;

	const userPreferences = useUserPreferences(),
		dispatch = useDispatch();

	const redirectionAfterCompleteIndependence = (engagementUserForIndependence) => {
		if (
			engagementUserForIndependence.independenceStatusId === independenceStatus.MATTERIDENTIFIEDPENDINGACTION ||
			engagementUserForIndependence.engagementAccessTypeId === engagementAccessType.INDEPENDENCEONLY
		) {
			window.location.href = env.getURL('Zeus_web');
			return;
		} else {
			window.location.href = env.getURL('hercules_web') + '/dashboard?engagementId=' + engagementId;
			return;
		}
	};

	const onSubmitIndependenceClick = () => {
		showLoading(true);
		setDisableButton(true);
		let requestURL =
			env.getBaseURL(serviceURL, engagementId) + 'InternalUsers/' + userPreferences?.id + '/IndependenceSubmit';
		window.sessionStorage.removeItem('validationsFilter');
		dispatch(submitIndependence(requestURL))
			.then((response) => {
				if (Object.keys(response).length > 0) {
					let snapshotRequestURL = createIndependenceSnapshotUrl(engagementId, documentId);

					dispatch(createCanvasFormSnapshot(snapshotRequestURL, {ApprovalId: 0})).finally(() => {
						redirectionAfterCompleteIndependence(response);
					});
				}
			})
			.catch(() => {
				dispatch(raiseJSValidationError(labels.independenceError));
				setDisableButton(false);
			})
			.finally(() => {
				showLoading(false);
			});
	};

	return (
		<StyledIndependenceFooter className="StyledIndependenceFooter StyledWrapper">
			{userPreferences?.id === document?.independenceInformation?.userId && (
				<Button
					className="StyledIndependenceFooterSubmit"
					onClick={onSubmitIndependenceClick}
					variant="primary"
					disabled={disableButton}
					showLabel
					buttonLabel={labels.submit}
					size="large"
				/>
			)}
		</StyledIndependenceFooter>
	);
}

const StyledIndependenceFooter = styled.section``;
